import React from 'react';
import GeoSentimentPill from './GeoSentimentPill';
import { formatGeoAvgPosition, formatGeoCoveragePct } from '../utils/geoPresentation';

export default function GeoPromptMetricsCells({ row, layout = 'default' }) {
  if (layout === 'mentionsFirst') {
    return (
      <>
        <td className="col-mentions">{row.brandMentions ?? 0}</td>
        <td className="col-position">{formatGeoAvgPosition(row.avgPosition)}</td>
        <td className="col-sentiment"><GeoSentimentPill value={row.sentiment} /></td>
        <td className="col-coverage">{formatGeoCoveragePct(row.coveragePct)}</td>
      </>
    );
  }

  return (
    <>
      <td className="col-coverage">{formatGeoCoveragePct(row.coveragePct)}</td>
      <td className="col-position">{formatGeoAvgPosition(row.avgPosition)}</td>
      <td className="col-sentiment"><GeoSentimentPill value={row.sentiment} /></td>
    </>
  );
}
